import {FC} from "react";
import {TabRow} from "../../../tab-content";
import {
  SimpleTable,
  TableBody,
  TableCell,
  TableRow
} from "@interstate/components/SimpleTable";
import {useTranslation} from "react-i18next";
import "./ClientTelecomNumbers.scss";

export interface ClientTelecomNumbersProps {
  custPhoneNumber?: string[];
  id: string;
}

export const ClientTelecomNumbers: FC<ClientTelecomNumbersProps> = ({
  custPhoneNumber,
  id
}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"client-telecom-numbers"}
      header={<h4>{t("entity-detail.dealer.phone")}</h4>}>
      <SimpleTable
        id={`client-telecom-numbers-table-${id}`}
        data-testid={`client-telecom-numbers-table-${id}`}
        dataDensity={"small"}
        background={"white"}
        className={"client-telecom-numbers-table"}
        bordered={false}
        hover={false}
        striped={false}>
        <TableBody
          id={`telecom-numbers-table-body-${id}`}
          data-testid={`telecom-numbers-table-body-${id}`}
          className={"telecom-numbers-table-body telecom-numbers-body"}>
          <TableRow className={"telecom-numbers-row"}>
            <TableCell className={"telecom-numbers-field"}>
              {t("entity-detail.dealer.phone")}
            </TableCell>
            <TableCell
              className={"telecom-numbers-value"}
              id={"telecom-numbers-phone-numbers"}>
              <ul className={"phone-numbers"}>
                {custPhoneNumber?.map((phone: string) => (
                  <li key={phone} className={"phone-number"}>
                    {phone}
                  </li>
                ))}
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </SimpleTable>
    </TabRow>
  );
};
